import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Project, ProjectResource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  projectResources: Identifiable<ProjectResource>[];
  retrieveProjectResources(
    request: Boundaries["retrieveProjectResources"]["request"],
  ): void;
}

function useProjectResourcesRetrieval(
  project: Identifiable<Project>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isProjectResourcesRetrievalRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isProjectResourcesRetrievalRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isProjectResourcesRetrievalRequestFailure(project),
    ),
    projectResources: useSelector(() => selector.getProjectResources(project)),
    retrieveProjectResources: core.retrieveProjectResources,
  };
}

export { useProjectResourcesRetrieval };
